import { validUrl, validateIPv4 } from 'utils/validate';

export const defaultSelectedLdap = {
  name: null,
  server: null,
  port: null,
  authMode: 'Simple',
  username: null,
  password: null,
  baseDN: null,
  accountAttr: null,
  identity: null,
  autoCopy: false,
};

export const getInitSelectedLdap = ({ selectedLdap = {} }) => {
  return {
    ...defaultSelectedLdap,
    ...(selectedLdap ?? {}),
  };
};

export const getIsServerInvalid = ({ server }) => {
  if (!server) return true;
  const tmpServer = String(server).trim();
  // If the value contains only digits and dots, treat it as IPv4 and require strict IPv4 validation
  if (/^[0-9.]+$/.test(tmpServer)) {
    return !validateIPv4(tmpServer);
  }

  // Otherwise allow either a valid domain/URL or an IPv4
  if (!validUrl(tmpServer) && !validateIPv4(tmpServer)) return true;
  return false;
};

export const getIsPortInvalid = ({ port }) => {
  if (!port) return true;
  const p = +port;
  return p < 1 || p > 65535;
};

export const getIsBaseDNInvalid = ({ baseDN }) => {
  if (!baseDN) return true;
  const v = String(baseDN).trim();
  // allow segments like key=value separated by commas, commas may have optional spaces after them
  // e.g. "ou=example,dc=com" or "ou=example, dc=com"
  // attribute=value pairs, value must not contain ',' or '=' to avoid malformed parts like '1==1'
  const pattern = /^\s*[A-Za-z0-9_-]+=[^,=]+(\s*,\s*[A-Za-z0-9_-]+=[^,=]+)*\s*$/;
  return !pattern.test(v);
};

export const getIsFormInvalid = ({ selectedLdap }) => {
  const { name, server, port, authMode, username, password, baseDN, accountAttr, identity } = selectedLdap || {};

  if (!name) return true;
  if (getIsServerInvalid({ server })) return true;
  if (getIsPortInvalid({ port })) return true;
  if (!authMode) return true;
  if (getIsBaseDNInvalid({ baseDN })) return true;
  if (!username || !password || !accountAttr || !identity) return true;

  return false;
};
